import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import ym from "react-yandex-metrika";

// https://yandex.ru/support/metrica/code/ajax-flash.html
export const useYandexMetrics = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    ym("hit", window.location.href);
  }, [location]);
};
